import { render } from "./arrival.vue?vue&type=template&id=68bc0ee8&scoped=true"
import script from "./arrival.vue?vue&type=script&lang=js"
export * from "./arrival.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./arrival.vue?vue&type=style&index=1&id=68bc0ee8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bc0ee8"]])

export default __exports__